import React, { useState } from "react";

import { decodeHandler, truncateStringMiddle } from "utils";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import { STATIC_VARIABLES } from "consts";
import { ReactComponent as BreadCrumbArrowIcon } from "assets/images/app_svg/breadcrumb_arrow.svg";
import { ReactComponent as BreadCrumbHomeIcon } from "assets/images/app_svg/breadcrumb_home.svg";

function BreadCrumbs(props) {
  const [dropCrumb, setDropCrumb] = useState(false);

  function toggleDropCrumb() {
    setDropCrumb(prevState => !prevState);
  }

  function truncateMiddle(str) {
    const breadCrumbElement = document.getElementById("breadcrumb_trunc");

    if (breadCrumbElement) {
      let crumbLength = props.enumFolder.breadCrumbs.length;
      const breadCrumbWidth =
        (550 + 50) /
        (crumbLength < STATIC_VARIABLES.breadcrumbDropdown
          ? crumbLength
          : STATIC_VARIABLES.breadcrumbDropdown);
      return truncateStringMiddle(
        str,
        "customRestoreBreadCrumb",
        30,
        breadCrumbWidth
      );
    }
    return str;
  }

  let content;
  if (props.enumFolder === undefined) content = null;
  else if (props.enumFolder.breadCrumbs === undefined) content = null;
  else if (props.enumFolder.breadCrumbs.length === 1) content = null;
  else {
    let crumbs = [...props.enumFolder.breadCrumbs];
    let dropdown;
    if (crumbs.length > STATIC_VARIABLES.breadcrumbDropdown) {
      dropdown = crumbs.splice(
        2,
        crumbs.length - STATIC_VARIABLES.breadcrumbDropdown
      );
      crumbs.splice(2, 0, "1");
    }
    content = (
      <ul className="breadcrumb_ul" id="breadcrumb_trunc">
        {crumbs.map((crumb, i) => {
          if (i === 0) {
            return (
              <li
                className="home"
                key={crumb.path}
                onClick={() =>
                  props.listEnum({
                    clientUUID: props.clientUUID,
                    path: crumb.path
                  })
                }
              >
                <span
                  className="icon"
                  data-toggle="tooltip"
                  title="Home"
                  data-original-title="Home"
                >
                  <BreadCrumbHomeIcon />
                </span>
              </li>
            );
          } else if (dropdown && i === 2) {
            return (
              <React.Fragment>
                <li className="arrow" key={i}>
                  {" "}
                  <span className="icon">
                    <BreadCrumbArrowIcon />
                  </span>{" "}
                </li>
                <ClickAwayListener onClickAway={() => setDropCrumb(false)}>
                  <li
                    className={["dropdown", dropCrumb ? "active" : ""].join(
                      " "
                    )}
                    onClick={() => toggleDropCrumb()}
                  >
                    <span title="Show Path">...</span>
                    <ul className="sub_breadcrumb_dd">
                      {dropdown.map(drop => (
                        <li
                          onClick={() =>
                            props.listEnum({
                              clientUUID: props.clientUUID,
                              path: drop.path
                            })
                          }
                          key={drop.path}
                          title={decodeHandler(drop.name)}
                        >
                          {decodeHandler(drop.name)}
                        </li>
                      ))}
                    </ul>
                  </li>
                </ClickAwayListener>
              </React.Fragment>
            );
          } else {
            return (
              <React.Fragment>
                <li className="arrow" key={i}>
                  {" "}
                  <span className="icon">
                    <BreadCrumbArrowIcon />
                  </span>{" "}
                </li>
                <li
                  className="content"
                  onClick={() =>
                    props.listEnum({
                      clientUUID: props.clientUUID,
                      path: crumb.path
                    })
                  }
                  key={crumb.path}
                  id="customRestoreBreadCrumb"
                  title={decodeHandler(crumb.name)}
                >
                  {truncateMiddle(decodeHandler(crumb.name))}
                </li>
              </React.Fragment>
            );
          }
        })}
      </ul>
    );
  }
  return content;
}

export default BreadCrumbs;
